import { Form, Modal, Select, SelectProps, Input } from 'antd';
import { uniq } from 'lodash-es';
import React, { forwardRef, useState, useImperativeHandle, ReactNode } from 'react';
import IconClose from '@/assets/images/icons/icon-close.react.svg?react';
import styles from './index.module.scss';

enum SplitModel {
  Newline='0', // 换行
  Semicolon='1', // 分号
  CommaOrNewline='2'
}
interface ISplitModalProps{
  title?: string;
  ref?: React.Ref<ISplitModalRef | undefined>;
  callBack: (value?: string[]) => void;
  trigger?: ReactNode;
  onTrigger?: () => void;
}

interface ISplitModalRef {
  showModal: (value?: string) => void;
}

const modelOptions: SelectProps['options'] = [
  { value: SplitModel.Newline, label: '使用回车进行分割' },
  { value: SplitModel.Semicolon, label: '使用英文分号进行分割' },
  { value: SplitModel.CommaOrNewline, label: '使用英文逗号或者回车进行分割' },
];

export const SplitModal: React.FC<ISplitModalProps> = forwardRef((props, ref) => {
  const { title, callBack } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const [form] = Form.useForm();
  useImperativeHandle(ref, () => ({
    showModal,
  }));

  const showModal = (value?: string) => {
    form.setFieldsValue({
      text: value,
    });
    setVisible(true);
  };
  const onCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const onConfirm = (values?: string[]) => {
    const uniqVersions = uniq(values || []);
    callBack(uniqVersions);
  };

  const onOk = () => {
    const model = form.getFieldValue('model');
    const text = form.getFieldValue('text');
    switch (model) {
      case SplitModel.Newline:
        onConfirm(text?.split('\n')?.filter?.((str: string) => !!str));
        break;
      case SplitModel.Semicolon:
        onConfirm(text?.replaceAll(/\n/g, '')?.split(';')
          ?.filter?.((str: string) => !!str));
        break;
      case SplitModel.CommaOrNewline:
        onConfirm(text?.split?.(/\n|,/)?.filter?.((str: string) => !!str));
        break;
      default:
        break;
    }
    onCancel();
  };

  return <>
    <Modal
      width={903}
      maskClosable={false}
      visible={visible}
      title={title || '分割'}
      closeIcon={<IconClose />}
      onCancel={onCancel}
      onOk={onOk}
      cancelButtonProps={{
        className: styles.cancelButton,
      }}
      okButtonProps={{
        style: { background: '#0A6CFF', borderRadius: '3px' },
      }}
      className={styles.modal}>
      <Form form={form} className={styles.form}>
        <Form.Item name={'model'} initialValue={SplitModel.Newline}>
          <Select className={'w-full'} options={modelOptions}/>
        </Form.Item>
        <Form.Item name={'text'} noStyle>
          <Input.TextArea rows={10}/>
        </Form.Item>
      </Form>
    </Modal>
    <span onClick={props.onTrigger}>
    {props.trigger}
    </span>
  </>;
});
